import { T } from '@transifex/react';
import { InfoBar } from '@wfp/ui';

export const OfflineBanner = () => (
  <InfoBar pageWidth="lg">
    <T _str="OFFLINE: You are currently offline and Partner Connect functionality is limited." />
  </InfoBar>
);
